import { apiAuth } from './index';

/**
 * Response: [{
 *  foodCategoryId: int
 *  foodCategoryName: string
 *  isEndOrderTime: bool
 *  invoiceClaimed: bool
 *  orderEditable: bool
 *  companyAddressId: int
 *  foodItemViewModels: [{
 *    foodItemName: string
 *    foodItemIngredients: string
 *    foodItemPrice: int
 *    foodItemDiscountedPrice: int
 *    foodItemId: int
 *    ordered: bool
 *    foodItemImage: string
 *    restaurantName: string
 *    invoiceItemQuantity: int
 *    visibility: bool
 *
 *    foodStockQuantity: int
 *    hasFoodStock: boolean
 *  }]
 * }]
 */
let storeData = null;
export const fetchMenu = async (dayId, useStoreData = false) => {
	if (storeData && useStoreData) return storeData;

	try {
		const { data } = await apiAuth.get(`company/menu?dayId=${dayId}&isInsideCompanyRestaurantItem=false`);
		storeData = data;
		return data;
	} catch (e) {
		throw e;
	}
};
export const fetchUserActiveTransactions = async () => {
	try {
		const { data } = await apiAuth.get(
			`bankTransaction/getActiveBankTransactions`,
		);
		return data;
	} catch (e) {
		throw e;
	}
};
